import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DoorDropsComponent } from './door-drops.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PurchaseEmissionsModule } from '../purchase-emissions/purchase-emissions.module';

@NgModule({
  declarations: [
    DoorDropsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PurchaseEmissionsModule
  ],
  exports: [
    DoorDropsComponent
  ]
})
export class DoorDropsModule { }
